import { render, staticRenderFns } from "./Aggregators.vue?vue&type=template&id=156ad5a6&scoped=true&lang=pug"
import script from "./Aggregators.vue?vue&type=script&lang=js"
export * from "./Aggregators.vue?vue&type=script&lang=js"
import style0 from "./Aggregators.vue?vue&type=style&index=0&id=156ad5a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156ad5a6",
  null
  
)

export default component.exports